import Collapse from 'components/collapse/Collapse';
import styled from 'styled-components';

export const ReviewTemplateModalContentContainer = styled.div``;

export const ReviewCategoriesCollapse = styled(Collapse)`
  margin-bottom: 10px;
`;
